import type { ElForm } from 'element-ui/types/form';
import { cloneDeep } from 'lodash';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  mixins: [style],
})
export default class AddPriceConfig extends Vue {
  @Prop({ default: () => {} })
    value: PriceConfigArrList;

  @Prop({ default: 0 }) index;

  @Prop({ default: false }) isPriceList;

  @Prop({ default: 0 }) maxFlag;

  data: PriceConfigArrList = null;

  rules = {
    min: [{ required: true, validator: this.validatorMin, trigger: 'blur' }],
    max: [{ required: true, validator: this.validatorMax, trigger: 'blur' }],
    content: [{ required: true, validator: this.validatorContent, trigger: 'blur' }],
  };

  $refs: {
    inputForm: ElForm;
    zkForm: ElForm;
  };

  @Watch('value', { deep: true, immediate: true })
  watchValue(n) {
    this.data = n;
  }

  @Watch('data', { deep: true, immediate: true })
  watchData(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.$emit('data', n);
    }
  }

  validatorMax(rules, value, callback) {
    if (value === '' || value === undefined || value === null) {
      callback(new Error(' '));
    } else if (value < this.data.min) {
      callback(new Error(' '));
    } else {
      callback();
    }
  }

  validatorMin(rules, value, callback) {
    if (value === '' || value === undefined || value === null) {
      callback(new Error(' '));
    } else if (value > this.data.max) {
      callback(new Error(' '));
    } else {
      callback();
    }
  }

  validatorContent(rules, value, callback) {
    if (value === undefined || value === null || value === '') {
      if (this.data.isShow === 0) {
        callback();
      } else {
        callback(new Error(' '));
      }
    } else {
      callback();
    }
  }

  add() {
    this.$emit('addItem');
  }

  minus() {
    this.$emit('minusItem', this.index);
  }

  maxChange(val) {
    const result = { index: this.index, con: val };
    this.$emit('maxChange', result);
  }

  changeContent(val) {
    this.data.content = val.replace(/\s*/g, '');
  }

  render(h) {
    return (
      <div>
        {this.isPriceList ? (
          <el-form inline={true} class="full-width guid-tag" props={{ model: this.data }} ref="inputForm" rules={this.rules}>
            <el-form-item>
              {this.index === 0 ? (
                <el-button icon="el-icon-plus" class="no-padding r-mr-24 wid-12 r-mt-8 hei-12" type="primary" circle onClick={this.add.bind(this)} />
              ) : (
                <el-button icon="el-icon-minus" class="no-padding r-mr-24 wid-12 r-mt-8 hei-12" type="primary" circle onClick={this.minus.bind(this)} />
              )}
            </el-form-item>

            <el-form-item class="wid-116" prop="min">
              <span>＞</span>
              <el-input-number controls={false} disabled={this.index === 0 ? false : true} class="wid-60 r-pl-24 r-pr-6" v-model={this.data.min} />元 <span class="r-pl-20">＜＝</span>
            </el-form-item>
            <el-form-item class="wid-96" prop="max">
              <el-input class="wid-60 r-pl-24 r-pr-6" disabled={this.index === this.maxFlag - 1 ? true : false} v-model={this.data.max} onChange={this.maxChange.bind(this)} />元
            </el-form-item>
            <el-form-item class="wid-110" prop="content">
              <el-input-number controls={false} precision={1} class="wid-60 r-pl-24 r-pr-6" v-model={this.data.content} />
              %选择
            </el-form-item>
          </el-form>
        ) : (
          <el-form inline={true} class="full-width guid-tag" ref="zkForm" props={{ model: this.data }} rules={this.rules}>
            <el-form-item>
              {this.index === 0 ? (
                <el-button icon="el-icon-plus" class="no-padding r-mr-24 r-mt-8 wid-12 hei-12" type="primary" circle onClick={this.add.bind(this)} />
              ) : (
                <el-button icon="el-icon-minus" class="no-padding r-mr-24 r-mt-8 wid-12 hei-12" type="primary" circle onClick={this.minus.bind(this)} />
              )}
            </el-form-item>
            <el-form-item class="wid-115" prop="min">
              <span>＞</span>
              <el-input-number controls={false} class="wid-60 r-pl-24 r-pr-6" v-model={this.data.min} disabled={this.index === 0 ? false : true} />% <span class="r-pl-20">＜＝</span>
            </el-form-item>
            <el-form-item class="wid-96" prop="max">
              <el-input-number controls={false} class="wid-60 r-pl-24 r-pr-6" v-model={this.data.max} disabled={this.index === this.maxFlag - 1 ? true : false} onChange={this.maxChange.bind(this)} />%
            </el-form-item>
            <el-form-item prop="content">
              <el-checkbox v-model={this.data.isShow} true-label={1} false-label={0}>
                前端展示为
              </el-checkbox>
              {this.data.isShow ? <el-input maxlength={8} v-model={this.data.content} onChange={this.changeContent.bind(this)} class="wid-100 r-pl-24" /> : ''}
            </el-form-item>
          </el-form>
        )}
      </div>
    );
  }
}
